// extracted by mini-css-extract-plugin
export default {"tabsContainer":"home_tabsContainer__fkaFC","dx-tabs":"home_dx-tabs__AtsBf"};